import { Select, Option } from 'element-ui'
import HttpFactory from '@/mixins/http.factory';
import download from "downloadjs";
import customAgGrid from '@/components/custom-ag-grid/custom-ag-grid.vue';
import dateTimeRenderer from '@/components/custom-ag-grid/dateTimeRenderer/dateTimeRenderer.vue';
import booleanRenderer from '@/components/custom-ag-grid/booleanRenderer/booleanRenderer.vue';
import devopsCustomerActionsRenderer from '@/components/admin/devopsCustomerActionsRenderer.vue';
import notifyRenderer from '@/components/admin/notifyRenderer.vue';
import copyColumnRenderer from '@/components/admin/copy-column.vue';
import devopsExtraActionsRenderer from '@/components/admin/devops-extra-actions.vue';
import customizeRenderer from '@/components/admin/customize.vue';

import DevopsFieldMapping from '../devops-field-mapping/devops-field-mapping.vue';
import DatePicker from '@/components/date-picker/date-picker.vue';
import Multiselect from 'vue-multiselect'
export default {
	mixins:[HttpFactory],
	data () {
		return {
            filters:{show:false,startDate:null,endDate:null,validUntil:null,appType:'',planType:'',planTypes:['Free','Trial'], searchText:null,isActive:1,isDeleted:'',columns:[]},
            payments:{showPayments:false,list:[],user:null,columnDefs:[]},
            allCustomers:[],
			customers:[],
            customer:null,
            columnDefs:[],
            gridOptionsApi:null,
            columns:["All","userId","appId","installationId","userName","hdEmail",
                "syncAllowed","devopsStatus","hdStatus","devopsStatusDesc","devSyncAllSts","hdAuthorId","allowSearch","projectsAllowed",
            "allowConfigOpt","autoHDDesc","autoCreateADO","autoCreateHD","autoSRItems","bypassRules","hdSupName","autoSyncingFwd","notes","autoSyncing","isPaid","reOrderbackLog","syncLog",'mapFields','autoHDTitleMap',
            "allowRelations", "accessAllowed", "isPremium", "isTokenValid", "isUsersAccess", "allowFields", "allowNodes", "allowTags", "allowHDTags", "allowCTypes","allowMultiUserOAuth", "isActive", "isDeleted", "syncAttachments", "defaultProject", "liveData",
            "allowMultiTenant","tenantsAllowed","defaultTenant","autoMapFields","uploadFiles","allowedCount","validUntil","createdOn","updatedOn","Extras","RefreshToken"],
            editedCustomer:null,
            showDelFieldMapping:false,
            editFieldMapping:null,
            deleteFieldMappingType:'ticket',
            fieldMappingTypes:[{name:'Tickets',value:'ticket'},{name:'Organization',value:'organization'},{name:'Changes',value:'change'}],
            showEditFieldMapping:false,
            showEditedCustomer: false,
            extendTrialPop: false,
            extendTrialData:null,
            options:[
                {name:'Paid Plan',value:"isPaid"},{name:'Bypass Rules',value:"bypassRules"},
                {name:'Sync All Status',value:"devSyncAllSts"},{name:'Map Author',value:"hdAuthorId"},{name:'Sync Attachments',value:"syncAttachments"},
                {name:'Search Tab',value:"allowSearch"},{name:'Config Option',value:"allowConfigOpt"},{name:'Auto HD Desc',value:"autoHDDesc"},{name:'Auto Create ADO',value:"autoCreateADO"},{name:'Auto Create HD',value:"autoCreateHD"},
                //{name:'Auto Syncing Reverse',value:"autoSyncing"},{name:'Auto Syncing Forward',value:"autoSyncingFwd"},
                {name:'Premium Plan',value:"isPremium"},{name:'Users API Access',value:"isUsersAccess"},{name:'Custom Fields',value:"allowFields"},{name:'Allow Multiple Tenants',value:"allowMultiTenant"},
                {name:'Nodes/Iterations',value:"allowNodes"},{name:'Tags Access',value:"allowTags"},{name:'HD Tags Access',value:"allowHDTags"},{name:'Custom Workitem Types',value:"allowCTypes"},//{name:'Allow Multi User OAuth',value:"allowMultiUserOAuth"},
                {name:'Active',value:"isActive"},{name:'Deleted',value:"isDeleted"},{name:'Files Upload',value:"uploadFiles"},{name:'ReOrder Backlogs',value:"reOrderbackLog"},
                //{name:'Sync Log',value:"syncLog"},{name:'Sync Fields',value:"mapFields"},{name:'Auto HD Title Map',value:"autoHDTitleMap"},{name:'Allow Relations',value:"allowRelations"},{name:'Allowed Access',value:"accessAllowed"}
            ],
            selectedOptions:[],
            showAllConfig:'False'
            
		};
	},
    created(){
        const _self=this;
        _self.showAllConfig=localStorage['showAllConfig']=='True'?'True':'False';
        _self.initCols();
		_self.init();
	},
	methods:{
        async init(){
            this.fetchData();
        },
        toggleFilters(){
            const _self=this;
            _self.fn().clearMessage();
            _self.filters.show=!_self.filters.show;
        },
        toggleConfig(){
            const _self=this;
            _self.fn().clearMessage();
            _self.customers=[];
            localStorage['showAllConfig']=_self.showAllConfig;
            setTimeout(function(){
                _self.customers=_self.allCustomers;
            },250);
        },
        async resetFiltersfn(){
            const _self=this;
            _self.fn().clearMessage();
            _self.filters={show:false,startDate:null,endDate:null,validUntil:null,appType:'',planType:'',planTypes:['Free','Trial'], searchText:null,isActive:1,isDeleted:'',columns:[]};
            _self.fetchData();
        },
        async fetchData(){
            const _self=this;
            //_self.fn().clearMessage();
            try{
                // let response=await _self.get('customers?requests=devops&isActive=True');
                // if(response && response.data){
                //     _self.allCustomers=response.data.Data;
                //     _self.customers=_self.allCustomers;
                // }else{
                //     _self.userMsg.list=['An error occurred!! Please try again later'];
                // }
                let data=JSON.parse(JSON.stringify(_self.filters));
                data.searchText=null;//currently need only on client side
                if(data.startDate) data.startDate=_self.fn().apiFormatedDate(new Date(data.startDate));
                if(data.endDate) data.startDate=_self.fn().apiFormatedDate(new Date(data.endDate));
                if(data.validUntil) data.startDate=_self.fn().apiFormatedDate(new Date(data.validUntil));
                let response=await _self.post('customers/search?requests=devops',data);
                if(response && response.data){
                    _self.allCustomers=response.data.Data;
                    _self.customers=_self.allCustomers;
                    _self.filterData();
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        onGridOptionsApi(params){
            const _self=this;
            _self.fn().clearMessage();
            _self.gridOptionsApi=params;
            setTimeout(function(){_self.filterData();},200);
        },
        async filterData(){
            const _self=this;
            _self.fn().clearMessage();
            const searchText=_self.filters.searchText;
            if(_self.gridOptionsApi && _self.gridOptionsApi.api){
                _self.gridOptionsApi.api.setQuickFilter(searchText);
            }
        },
        refreshUser(params){
            const _self=this;
            let data=params.data;
            if(confirm(`Are you sure? You want to refresh the details!!!for App:${data.requestType} for email:${data.userEmail}`)){
                _self.updateCustomer(data,'refresh=true');
            }
        },
        extraCallBackFn(params){
            const _self = this;
            let data=params.data;
            if(confirm(`Are you sure? You want to Toggle Paid customer!!!for App:${data.requestType} for email:${data.userEmail}`)){
                data.isPaid=data.isPaid==1?0:1;
                if(data.isPaid==0){
                    data.isPremium=0;
                    data.isUsersAccess=0;
                }else{
                    data.isActive=1;
                    data.isDeleted=0;
                }
                _self.updateCustomer(data);
            }
        },
        extraCallBackFn1(params){
            const _self = this;
            let data=params.data;
            if(confirm(`Are you sure? You want to Toggle Premium customer!!!for App:${data.requestType} for email:${data.userEmail}`)){
                data.isPremium=data.isPremium==1?0:1;
                if(data.isPremium==0){
                    data.isUsersAccess=0;
                }else{
                    data.isActive=1;
                    data.isDeleted=0;
                    data.isPaid=1;
                }
                _self.updateCustomer(data);
            }
        },
        extraCallBackFn2(params){
            const _self = this;
            let data=params.data;
            if(confirm(`Are you sure? You want to Toggle Active customer!!!for App:${data.requestType} for email:${data.userEmail}`)){
                data.isActive=data.isActive==1?0:1;
                if(data.isActive==0){
                    //data.isPaid=0;
                    //data.isPremium=0;
                    //data.isUsersAccess=0;
                }else{
                    data.isDeleted=0;
                }
                _self.updateCustomer(data);
            }
        },
        extraCallBackFn3(params){
            const _self=this;
            let data=params.data;
            if(data.type=='1' && confirm(`Are you sure!! You are about to permanently delete customer for App:${data.requestType} for email:${data.userEmail}`)){
                _self.deleteCustomer(data);
            }

            else if(data.type=='0' && confirm(`Are you sure? You want to Toggle Deleted customer!!! For App:${data.requestType} for email:${data.userEmail}`)){
                data.isDeleted=data.isDeleted==1?0:1;
                data.isActive=0;
                _self.updateCustomer(data);
            }
        },
        async deleteCustomer(data){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let response=await _self.delete(`customers/${data.userId}/${data.requestType}/${data.type}`,data);
                if(response && response.data){
                    _self.userMsg.type='info';
                    _self.userMsg.list=['Data updated successfully'];
                    _self.fetchData();
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        extraCallBackFn3_no(params){
            const _self = this;
            let data=params.data;
            if(confirm(`Are you sure? You want to Toggle Deleted customer!!!for App:${data.requestType} for email:${data.userEmail}`)){
                data.isDeleted=data.isDeleted==1?0:1;
                if(data.isDeleted==0){
                    data.isActive=0;
                    data.isPaid=0;
                    data.isPremium=0;
                    data.isUsersAccess=0;
                }
                _self.updateCustomer(data);
            }
        },
        extraCallBackFn6(params){
            const _self = this;
            let data=params.data;
            if(confirm(`Are you sure? You want to Toggle Users API Access customer!!!for App:${data.requestType} for email:${data.userEmail}`)){
                data.isUsersAccess=data.isUsersAccess==1?0:1;
                _self.updateCustomer(data);
            }
        },
        extraCallBackFn7(params){
            const _self=this;
            let data=params.data;
            if(confirm(`Are you sure!! You are about to delete config for App:${data.requestType} for email:${data.userEmail}`)){
                _self.deleteMapping(data);
            }
        },
        extraCallBackFn9(params){
            const _self=this;
            let data=params.data;
            _self.deleteFieldMappingType='ticket';
            _self.editedCustomer=params.data;
            _self.showDelFieldMapping=true;
            //if(confirm(`Are you sure!! You are about to delete field mapping for App:${data.requestType} for email:${data.userEmail}`)){
            //  _self.deleteFieldMapping(data,_self.deleteFieldMappingType);
            //}
        },
        extraCallBackFn10(params){
            const _self=this;
            let data=params.data;
            _self.editedCustomer=params.data;
            _self.showEditFieldMapping=true;
            //if(confirm(`Are you sure!! You are about to delete field mapping for App:${data.requestType} for email:${data.userEmail}`)){
            //  _self.deleteFieldMapping(data,_self.deleteFieldMappingType);
            //}
        },
        hideEditFieldMappingFn(){
            const _self=this;
            _self.showEditFieldMapping=false;
            _self.editedCustomer=null;
        },
        //extend trial
        extraCallBackFn8(data){
            const _self = this;
            
            _self.fn().clearMessage();
            data.trialExtendDays=data.trialExtendDays?data.trialExtendDays:7;
            _self.extendTrialData=data;
            setTimeout(function () { _self.extendTrialPop = true; }, 500);
            
            ////let data=params.data;
            // if(confirm(`Are you sure!! You are about to extend trial for App:${data.requestType} for email:${data.userEmail}`)){
            //     _self.extendTrialFn(data);
            // }
        },
        async extraCallBackFn5(params){
            this.sendNotification(params.data);
        },
        async deleteFieldMapping(){
            const _self=this;
            _self.fn().clearMessage();
            let data=_self.editedCustomer;
            try{
                let response=await _self.delete(`fieldmapping/delete/${data.userId}/${data.requestType}/${_self.deleteFieldMappingType}`,data);
                if(response && response.data){
                    _self.userMsg.type='info';
                    _self.userMsg.list=['Data updated successfully'];
                    _self.showDelFieldMapping=false;
                    _self.editedCustomer=null;
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        async deleteMapping(data){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let response=await _self.delete(`customfield/${data.userId}/${data.requestType}`,data);
                if(response && response.data){
                    _self.userMsg.type='info';
                    _self.userMsg.list=['Data updated successfully'];
                    _self.fetchData();
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        async extendTrialFn(){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let data = {
                    userId: _self.extendTrialData.userId,
                    requestType: _self.extendTrialData.requestType,
                    devOpsUrl: _self.extendTrialData.devOpsUrl,
                    hdLoginUrl: _self.extendTrialData.hdLoginUrl,
                    
                    trialExtendDays: _self.extendTrialData.trialExtendDays,
                };
                let response=await _self.put(`extendTrial/${data.userId}/${data.requestType}`,data);
                if(response && response.data){
                    _self.userMsg.type='info';
                    _self.userMsg.list = ['Data updated successfully'];
                     _self.closeExtendTrialFn();
                    
                    _self.fetchData();
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        closeExtendTrialFn() {
            const _self=this;
            //_self.fn().clearMessage();
            _self.extendTrialPop = false; 
            setTimeout(function () {_self.extendTrialData = null;}, 500);
        },
        async sendNotification(pData){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let data={
                    type:pData.type,
                    userId:pData.userId,
                    requestType:pData.requestType
                };
                if(!data.type)return;
                if(confirm(`Are you sure!! You are about to notify App:${data.requestType} for type:${data.type}`)){
                    let response=await _self.post(`notify/devops/${data.type}/${data.userId}/${data.requestType}`,data);
                    if(response && response.data && response.data.Success){
                        _self.userMsg.type='info';
                        _self.userMsg.list=['Notification sent successfully'];
                    }else{
                        _self.userMsg.list=['An error occurred!! Please try again later'];
                    }
                    _self.userMsg.show=true;
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
                _self.userMsg.show=true;
			}finally{
				_self.fn().showLoader(false);
			}
        },
        //payments view
        async extraCallBackFn4(params){
            const _self=this;
            _self.fn().clearMessage();
            try{
                _self.hidePayments();
                let data={
                    userId:params.data.userId,
                    requestType:params.data.requestType
                };
                _self.payments.user=params.data;
                let response=await _self.get(`payments/user/${data.userId}/${data.requestType}`);
                if(response && response.data){
                    _self.payments.list=response.data.Data;
                    _self.payments.showPayments=true;
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                    _self.userMsg.show=true;
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
                _self.userMsg.show=true;
			}finally{
				_self.fn().showLoader(false);
			}
        },
        hidePayments(){
            const _self=this;
            _self.fn().clearMessage();
            _self.payments.showPayments=false;
            _self.payments.list=[];
            _self.payments.user=null;
        },
        editCustomerConfig(data){
            const _self=this;
            _self.fn().clearMessage();
            _self.selectedOptions=JSON.parse(JSON.stringify(data.selectedOptions));
            _self.editedCustomer=data;
            setTimeout(function(){_self.showEditedCustomer=true;},500);
        },
        async updateCustomerConfig(){
            const _self=this;
            _self.fn().clearMessage();
            if(confirm(`Are you sure ? You are about to update the config!!!`)){
                let data={
                    userId:_self.editedCustomer.userId,
                    requestType:_self.editedCustomer.requestType,

                    notes:_self.editedCustomer.notes,
                    hdStatus:_self.editedCustomer.hdStatus,
                    devopsStatus:_self.editedCustomer.devopsStatus,
                    devopsStatusDesc:_self.editedCustomer.devopsStatusDesc,
                    devOpsUrl:_self.editedCustomer.devOpsUrl,
                    hdSupName:_self.editedCustomer.hdSupName
                };
                for(var i=0;i<_self.options.length;i++){
                    let isSelected=_self.selectedOptions.find(d=>d.value==_self.options[i].value);
                    data[_self.options[i].value]=isSelected?1:0;
                }
                _self.updateCustomerConfigFn(data);  
            }
            //updateCustomerConfig
        },
        async updateCustomerConfigFn(params){
            const _self=this;
            _self.fn().clearMessage();
            try{
                let response=await _self.put(`customers/${params.userId}`,params);
                if(response && response.data){
                    _self.userMsg.type='info';
                    _self.userMsg.list=['Customer Config updated successfully'];
                    _self.fetchData();
                    setTimeout(function(){ _self.showEditedCustomer=false;},500);
                    setTimeout(function(){ _self.editedCustomer=null;},1000);
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        async updateCustomer(params,queryParams){
            const _self = this;
            queryParams = queryParams ? queryParams : '';
            _self.fn().clearMessage();
            try{
                let data={
                    userId:params.userId,
                    appId:params.appId,
                    installationId:params.installationId,
                    isPaid:params.isPaid,
                    userEmail:params.userEmail,
                    isPremium:params.isPremium,
                    isUsersAccess:params.isUsersAccess,
                    allowTags:params.allowTags,
                    allowHDTags:params.allowHDTags,
                    allowFields:params.allowFields,
                    allowNodes:params.allowNodes,
                    allowCTypes: params.allowCTypes,
                    allowMultiUserOAuth:params.allowMultiUserOAuth,
                    autoSyncing:params.autoSyncing,
                    autoSyncingFwd:params.autoSyncingFwd,
                    syncAllowed:params.syncAllowed?params.syncAllowed:null,
                    syncAttachments:params.syncAttachments?params.syncAttachments:null,
                    uploadFiles:params.uploadFiles?params.uploadFiles:null,
                    isActive:params.isActive,
                    isTokenValid:params.isTokenValid,
                    isDeleted:params.isDeleted,
                    requestType:params.requestType,
                    notes:params.notes?params.notes:null,
                };
                    data.hdStatus=params.hdStatus?params.hdStatus:null;
                    data.devopsStatus=params.devopsStatus?params.devopsStatus:null;
                    data.devopsStatusDesc=params.devopsStatusDesc?params.devopsStatusDesc:null;
                    data.devOpsUrl=params.devOpsUrl;

                    data.autoSRItems=params.autoSRItems?params.autoSRItems:0;
                    data.hdAuthorId=params.hdAuthorId?params.hdAuthorId:0;
                    data.bypassRules=params.bypassRules?params.bypassRules:0;
                    data.devSyncAllSts=params.devSyncAllSts?params.devSyncAllSts:0;
                    data.allowSearch=params.allowSearch?params.allowSearch:0;
                    data.allowConfigOpt=params.allowConfigOpt?params.allowConfigOpt:0;
                    data.autoHDDesc=params.autoHDDesc?params.autoHDDesc:0;
                    data.autoCreateADO=params.autoCreateADO?params.autoCreateADO:0;
                    data.autoCreateHD=params.autoCreateHD?params.autoCreateHD:0;
                    data.reOrderbackLog=params.reOrderbackLog?params.reOrderbackLog:0;
                    data.syncLog=params.syncLog?params.syncLog:'none';
                    data.mapFields=params.mapFields?params.mapFields:'none';
                    data.autoHDTitleMap=params.autoHDTitleMap?params.autoHDTitleMap:0;
                    data.allowRelations=params.allowRelations?params.allowRelations:0;
                    data.accessAllowed=params.accessAllowed?params.accessAllowed:'ticket';
                    data.projectsAllowed=params.projectsAllowed?params.projectsAllowed:0;
                    data.defaultProject = params.defaultProject ? params.defaultProject : null;
                    data.liveData = params.liveData ? params.liveData : 'none';
                    data.allowMultiTenant = params.allowMultiTenant ? params.allowMultiTenant : 0;    
                    data.tenantsAllowed = params.tenantsAllowed ? params.tenantsAllowed : 0;
                    data.defaultTenant = params.defaultTenant ? params.defaultTenant : null;
                    data.autoMapFields = params.autoMapFields ? params.autoMapFields : null;
                
                    data.hdSupName=params.hdSupName?params.hdSupName:null;

                let response=await _self.put(`customers/${data.userId}?${queryParams}`,data);
                if(response && response.data){
                    _self.userMsg.type='info';
                    _self.userMsg.list=['Data updated successfully'];
                    _self.fetchData();
                }else{
                    _self.userMsg.list=['An error occurred!! Please try again later'];
                }
            }catch(ex){
				_self.commonErrorMsgDisp(ex);
			}finally{
				_self.userMsg.show=true;
				_self.fn().showLoader(false);
			}
        },
        exportData(){
			let _self=this;
            _self.fn().clearMessage();
			let customers=_self.customers;
			//_self.fn().sortNumCol(customers,'createdOn',true);
			let defaultNullVal='-';
			let fileName = `customers.csv`;
			let csvData = `User Id, App Id, Installation Id, User Name, User Email, HD Email, HD Login Url, DevOps Url, Allowed Count, Valid Until, Token Valid, Active, Paid, Premium, Tickets Count, App Name, CreatedOn \r\n`;
			customers.forEach(function (item) {
                let integration='devOps';
                let row = `${_self.fn().formatCSV(item.userId?item.userId:defaultNullVal)},${_self.fn().formatCSV(item.appId?item.appId:defaultNullVal)},${_self.fn().formatCSV(item.installationId?item.installationId:defaultNullVal)},${_self.fn().formatCSV(item.userName?item.userName:defaultNullVal)},${_self.fn().formatCSV(item.userEmail?item.userEmail:defaultNullVal)},${_self.fn().formatCSV(item.hdEmail?item.hdEmail:defaultNullVal)},${_self.fn().formatCSV(item.hdLoginUrl?item.hdLoginUrl:defaultNullVal)},${_self.fn().formatCSV(item[`${integration}Url`])},${_self.fn().formatCSV(item.allowedCount?item.allowedCount:defaultNullVal)},${_self.fn().formatCSV(item.validUntil?item.validUntil:defaultNullVal)},${_self.fn().formatCSV(item.isTokenValid?item.isTokenValid:defaultNullVal)},${_self.fn().formatCSV(item.isActive?item.isActive:defaultNullVal)},${_self.fn().formatCSV(item.isPaid?item.isPaid:defaultNullVal)},${_self.fn().formatCSV(item.isPremium?item.isPremium:defaultNullVal)},${_self.fn().formatCSV(item.linkedCount?item.linkedCount:defaultNullVal)},${_self.fn().formatCSV(item.requestType?item.requestType:defaultNullVal)},${_self.fn().formatCSV(item.createdOn?item.createdOn:defaultNullVal)}`;
				csvData += row + "\r\n";
			});
			download(csvData, fileName, 'data:application/csv;charset=utf-8');
		},
        onStartDateChanged(date){
            const _self=this;
            _self.fn().clearMessage();
            if(_self.filters.endDate==null)_self.filters.endDate=new Date();
            if(_self.filters.startDate!=date){ //if previous start date and now is not same{
              _self.filters.startDate=date;
              _self.applyDateRangeFilter(true);
            }
        },
        onEndDateChanged(date){
            const _self=this;
            _self.fn().clearMessage();
            if(_self.filters.endDate!=date){ //if previous end date and now is not same{
              _self.filters.endDate=date;
              _self.applyDateRangeFilter(false);
            }
        },
        onValidUntilDateChanged(date){
            const _self=this;
            if(_self.filters.validUntil!=date){ //if previous end date and now is not same{
                _self.filters.validUntil=date;
                _self.applyDateRangeFilter(false);
            }
        },
        applyDateRangeFilter(isStartDateChanged){
            const _self=this;
            // _self.fn().clearMessage();
            // if(_self.filters.startDate==null || _self.filters.endDate==null){
            //     _self.userMsg={show:true,type:'danger',list:['Please select start and end date']};
            //     return;
            // }
            _self.filterCustomersApi(true);
        },
        async filterCustomersApi(){
            const _self=this;
            _self.fn().clearMessage();
            this.fetchData();
        },
        clearAllCols(){
            const _self=this;
            _self.fn().clearMessage();
            this.filters.columns=[];
            this.filterColsChanged();
        },
        clearAllOptCols(){
            const _self=this;
            _self.fn().clearMessage();
            this.selectedOptions=[];
        },
        filterColsChanged(){
            const _self=this;
            _self.fn().clearMessage();
            _self.initCols();
            // columns:["userId","appId","installationId","userName",
            //     "syncAllowed","hdStatus","devopsStatus","devopsStatusDesc","devSyncAllSts","hdAuthorId","allowSearch",
            // "allowConfigOpt","autoHDDesc","autoCreateADO","autoCreateHD","bypassRules","hdSupName","autoSyncingFwd","notes","autoSyncing","isPaid",
            // "isPremium","isUsersAccess","allowFields","allowNodes","allowTags","allowHDTags","allowCTypes","allowMultiUserOAuth","isActive","syncAttachments",
            // "uploadFiles"],


            // const allColumns = columnApi.getAllColumns().forEach((c) => {
            //     columnApi.setColumnVisible(c.getColId(), false);
            // });
        },
        isFilterColAllowed(colName){
            const _self=this;
            _self.fn().clearMessage();
            if(_self.filters.columns.indexOf('All')>=0) return true;
            if(_self.columns.indexOf(colName)<0) return true;//actions

            return _self.filters.columns.indexOf(colName)>=0;
        },
        initCols(){
            const _self  =this;
            _self.columnDefs=[];
          
            let commonWidth=125;//=120;
            let columnDefs = [
                { headerName: 'App',pinned:'left',maxWidth:90, field: 'requestType',cellClass:'text-capitalize', width: commonWidth,
                    valueFormatter:function(params){return params.value.split('-')[0];} 
                },
                { headerName: 'Valid - Created', field: 'createdOn',width: commonWidth,
                    valueFormatter:function(params){
                        let date=_self.filter().formatDate(params.data.createdOn);
                        let date1=_self.filter().formatDate(params.data.validUntil);
                        return `${date1?date1:'-'}/${date?date:'-'}`;
                    }
                },
                { headerName: 'User Email', field: 'userEmail',width: commonWidth,cellRendererFramework:copyColumnRenderer,editable:true, 
                    valueFormatter(params){
                        return `(${params.data.linkedCount}) ${params.value?params.value:'NA'}`;
                    },
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.userEmail=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    }, 
                },
                // { headerName: 'Tickets Count', field: 'linkedCount',width: commonWidth,
                //     cellRenderer:function(params){
                //         return `<a href="/admin/tickets/${params.data.userId}/${params.data.requestType}" target="_blank">${params.value}</a>`;
                //     } 
                // },
                { headerName: 'Last Tickets', field: 'lastDayCount',width: commonWidth,
                    valueFormatter:function(params){
                        return `${params.data.currentDayCount}/${params.value}`
                    }
                },
                { headerName: 'Last Used On', field: 'currentDayUsedOn',width: commonWidth,
                    cellRenderer:function(params){
                        let date=_self.filter().formatDate(params.value);
                        let date1=_self.filter().formatDate(params.data.currentDayUsedOn);
                        return `<a href="/admin/tickets/${params.data.userId}/${params.data.requestType}" target="_blank">${date1?date1:'-'}/${date?date:'-'}</a>`;
                        //return `${date1?date1:'-'}/${date?date:'-'}`;
                    }
                },
                { headerName: 'Agents Plan', field: 'planTotAgents',width: commonWidth,
                    valueFormatter:function(params){
                        let planCurrAgents=params.data.planCurrAgents===null?'NA':params.data.planCurrAgents;
                        let planTotAgents=params.data.planTotAgents===null?'NA':params.data.planTotAgents;

                        planCurrAgents=planCurrAgents===undefined?'NA':planCurrAgents;
                        planTotAgents=planTotAgents===undefined?'NA':planTotAgents;
                        return `${planCurrAgents}/${planTotAgents}`
                    }
                },
                { headerName: 'Tickets Plan', field: 'planTotTickets',width: commonWidth,
                    valueFormatter:function(params){
                        let planCurrTickets=params.data.planCurrTickets==null?'NA':params.data.planCurrTickets;
                        let planTotTickets=params.data.planTotTickets==null?'NA':params.data.planTotTickets;

                        planCurrTickets=planCurrTickets===undefined?'NA':planCurrTickets;
                        planTotTickets=planTotTickets===undefined?'NA':planTotTickets;

                        return `${planCurrTickets}/${planTotTickets}`
                    }
                },
                { headerName: 'HD Login Url', field: 'hdLoginUrl',width: commonWidth,cellRendererFramework:copyColumnRenderer },
                { headerName: 'Notify',pinned:'right', field: 'requestType',autoHeight:true,width: commonWidth,cellRendererFramework:notifyRenderer },
                { headerName: 'DevOps Url', field: 'devOpsUrl',width: commonWidth,cellRendererFramework:copyColumnRenderer},
                { headerName: 'Enabled Features', field: 'userId',autoHeight:true,editable:false, width: commonWidth,cellRendererFramework:customizeRenderer },
                { headerName: 'Notes', field: 'notes',width: 250,autoHeight: true,
                    minWidth: 250,
                    cellEditor:'agLargeTextCellEditor',editable:true,cellStyle:{'white-space': 'pre-line'},
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.notes=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
            ];
            
            //cust
            if(_self.isFilterColAllowed('hdEmail')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'HD Email', field: 'hdEmail',width: 170,
                        cellEditor:'agTextCellEditor',cellRendererFramework:copyColumnRenderer,editable:false,
                        onCellValueChanged: (params) => {
                            if(params.oldValue!=params.newValue){
                                params.data.hdEmail=params.newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('createdOn')){
                columnDefs=columnDefs.concat([
                    { headerName: 'Created On', field: 'createdOn',width: commonWidth,cellRendererFramework:dateTimeRenderer }
                ]);
            }

            if(_self.isFilterColAllowed('validUntil')){
                columnDefs=columnDefs.concat([
                    { headerName: 'Valid Until', field: 'validUntil',width: commonWidth,cellRendererFramework:dateTimeRenderer }
                ]);
            }

            if(_self.isFilterColAllowed('userId')){
                columnDefs=columnDefs.concat([
                    { headerName: 'User Id', field: 'userId', width: commonWidth,cellClass:'text-left'}
                ]);
            }
            if(_self.isFilterColAllowed('appId')){
                columnDefs=columnDefs.concat([
                    { headerName: 'App Id', field: 'appId',editable:true,width: commonWidth,
                        onCellValueChanged: (params) => {
                            if(params.oldValue!=params.newValue){
                                params.data.appId=params.newValue;
                                _self.updateCustomer(params.data);
                            }
                        }, 
                    },
                ]);
            }
            if(_self.isFilterColAllowed('installationId')){
                columnDefs=columnDefs.concat([
                    { headerName: 'Installation Id', field: 'installationId',editable:true,width: commonWidth,
                        onCellValueChanged: (params) => {
                            if(params.oldValue!=params.newValue){
                                params.data.installationId=params.newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('hdStatus')){
                columnDefs=columnDefs.concat([
                    { headerName: 'HD Status', field: 'hdStatus',width: 170,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            if(params.oldValue!=params.newValue){
                                params.data.hdStatus=params.newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('devopsStatus')){
                columnDefs=columnDefs.concat([
                    { headerName: 'DevOps Status', field: 'devopsStatus',width: 170,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            if(params.oldValue!=params.newValue){
                                params.data.devopsStatus=params.newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('devopsStatusDesc')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'DevOps Status Desc', field: 'devopsStatusDesc',width: 250,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            if(params.oldValue!=params.newValue){
                                params.data.devopsStatusDesc=params.newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('hdAuthorId')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'HD AuthorId', field: 'hdAuthorId',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.hdAuthorId=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('bypassRules')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'ByPass Rules', field: 'bypassRules',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.bypassRules=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('devSyncAllSts')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Sync All Sts', field: 'devSyncAllSts',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.devSyncAllSts=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('hdSupName')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Custom Supp Name', field: 'hdSupName',width: 170,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            if(params.oldValue!=params.newValue){
                                params.data.hdSupName=params.newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('allowSearch')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow Search', field: 'allowSearch',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowSearch=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('allowConfigOpt')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow Config Opt', field: 'allowConfigOpt',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowConfigOpt=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('autoHDDesc')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto HD Desc', field: 'autoHDDesc',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.autoHDDesc=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            
            if(_self.isFilterColAllowed('autoCreateADO')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto Create ADO', field: 'autoCreateADO',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.autoCreateADO=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('autoCreateHD')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto Create HD', field: 'autoCreateHD',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.autoCreateHD=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('allowedCount')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allowed Count', field: 'allowedCount',width: commonWidth },
                ]);
            }
            if(_self.isFilterColAllowed('allowTags')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allowed Tags', field: 'allowTags',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        //cellEditorParams: { values: ['Yes','No'] },
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                            // valueFormatter: (params) => {
                            //     return params.value==1?'Yes':'No'
                            // },
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowTags=newValue;
                                _self.updateCustomer(params.data);
                            }
                            // let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            // if(params.oldValue!=newValue){
                            //     params.data.allowTags=newValue;
                            //     _self.updateCustomer(params.data);
                            // }
                        },
                        //cellRendererFramework:booleanRenderer
                    },
                ]);
            }
            if(_self.isFilterColAllowed('allowHDTags')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allowed HD Tags', field: 'allowHDTags',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowHDTags=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            
            if(_self.isFilterColAllowed('allowFields')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow Fields', field: 'allowFields',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        //cellEditorParams: { values: ['Yes','No'] },
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                            // valueFormatter: (params) => {
                            //     return params.value==1?'Yes':'No'
                            // },
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowFields=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('allowNodes')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow Nodes', field: 'allowNodes',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowNodes=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('allowCTypes')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow CTypes', field: 'allowCTypes',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowCTypes=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('allowMultiUserOAuth')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow Multi User OAuth', field: 'allowMultiUserOAuth',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowMultiUserOAuth=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('autoSyncing')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto Sync', field: 'autoSyncing',width: 170,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: ['Select','all','tag_based','status'] },
                        filterParams: {
                            valueFormatter: (params) => {
                                return params.value==null?'Select':params.value;
                            },
                        },
                        onCellValueChanged:function(params,s){
                            let newValue=params.newValue;
                            if(newValue=='Select'){
                                newValue=null;
                            }
                            if(params.oldValue!=newValue){
                                params.data.autoSyncing=newValue;
                                _self.updateCustomer(params.data);
                            }
                        }
                    },
                ]);
            }
            if(_self.isFilterColAllowed('autoSyncingFwd')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto Sync Fwd', field: 'autoSyncingFwd',width: 170,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: ['Select','all','tag_based','private'] },
                        filterParams: {
                            valueFormatter: (params) => {
                                return params.value==null?'Select':params.value;
                            },
                        },
                        onCellValueChanged:function(params,s){
                            let newValue=params.newValue;
                            if(newValue=='Select'){
                                newValue=null;
                            }
                            if(params.oldValue!=newValue){
                                params.data.autoSyncingFwd=newValue;
                                _self.updateCustomer(params.data);
                            }
                        }
                    },
                ]);
            }
            if(_self.isFilterColAllowed('syncAllowed') || 1==1){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Syncing Allowed', field: 'syncAllowed',width: 170,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: ['Select','Forward','Reverse','Both'] },
                        filterParams: {
                            valueFormatter: (params) => {
                                return params.value==null?'Select':params.value;
                            },
                        },
                        onCellValueChanged:function(params,s){
                            let newValue=params.newValue;
                            if(newValue=='Select'){
                                newValue=null;
                            }
                            if(params.oldValue!=newValue){
                                params.data.syncAllowed=newValue;
                                _self.updateCustomer(params.data);
                                if(newValue){
                                    params.data.type='syncing';
                                    setTimeout(function(){
                                        _self.sendNotification(params.data);
                                    },1000);
                                }
                            }
                        }
                    },
                ]);
            }
            if(_self.isFilterColAllowed('syncAttachments')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Sync Attach..', field: 'syncAttachments',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.syncAttachments=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('autoSRItems')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto Sync SR Items', field: 'autoSRItems',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.autoSRItems=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('uploadFiles')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Upload Files', field: 'uploadFiles',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.uploadFiles=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('isTokenValid')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Token Valid', field: 'isTokenValid',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.isTokenValid=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            
            if(_self.isFilterColAllowed('reOrderbackLog')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'ReOrder BackLog', field: 'reOrderbackLog',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.reOrderbackLog=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('syncLog')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Sync Log', field: 'syncLog',width: 170,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: ['none','all', 'private', 'public'] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue=='Select'?'none':params.newValue;
                            if(params.oldValue!=newValue){
                                params.data.syncLog=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('mapFields')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Map Fields', field: 'mapFields',width: 170,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: ['none','front-end', 'back-end','both'] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue=='Select'?'none':params.newValue;
                            if(params.oldValue!=newValue){
                                params.data.mapFields=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('autoHDTitleMap')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto HD Title Map', field: 'autoHDTitleMap',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.autoHDTitleMap=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('allowRelations')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow Relations', field: 'allowRelations',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowRelations=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('accessAllowed')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allowed Access', field: 'accessAllowed',width: 150,
                        cellEditor: 'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue;
                            if(params.oldValue!=newValue){
                                params.data.accessAllowed=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            

            if(_self.isFilterColAllowed('projectsAllowed')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Projects Allowed', field: 'projectsAllowed',width: 200,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue?params.newValue:0;
                            if(params.oldValue!=newValue){
                                params.data.projectsAllowed=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('defaultProject')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Default Project', field: 'defaultProject',width: 200,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue?params.newValue:null;
                            if(params.oldValue!=newValue){
                                params.data.defaultProject=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            
            if(_self.isFilterColAllowed('liveData')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Live Data', field: 'liveData',width: 170,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: ['none', 'all', 'projects', 'fields', 'nodes', 'workItemTypes', 'users'] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue=='Select'?'none':params.newValue;
                            if(params.oldValue!=newValue){
                                params.data.liveData=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('allowMultiTenant')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Allow Multi Tenants', field: 'allowMultiTenant',width: 150,
                        cellEditor: 'agSelectCellEditor',editable:true,
                        cellEditorParams: { values: [1,0] },
                        filterParams: {
                        },
                        onCellValueChanged: (params) => {
                            let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                            if(params.oldValue!=newValue){
                                params.data.allowMultiTenant=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('tenantsAllowed')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Tenants Allowed', field: 'tenantsAllowed',width: 200,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue?params.newValue:0;
                            if(params.oldValue!=newValue){
                                params.data.tenantsAllowed=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('defaultTenant')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Default Tenant', field: 'defaultTenant',width: 200,
                        cellEditor:'agTextCellEditor',editable:true,
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue?params.newValue:null;
                            if(params.oldValue!=newValue){
                                params.data.defaultTenant=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }
            if(_self.isFilterColAllowed('autoMapFields')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Auto Map Fields', field: 'autoMapFields',
                        //cellEditor:'agTextCellEditor',editable:true,width: 200,
                        minWidth: 250,
                        cellEditor:'agLargeTextCellEditor',editable:true,cellStyle:{'white-space': 'pre-line'},
                        onCellValueChanged: (params) => {
                            let newValue=params.newValue?params.newValue:null;
                            if(params.oldValue!=newValue){
                                params.data.autoMapFields=newValue;
                                _self.updateCustomer(params.data);
                            }
                        },
                    },
                ]);
            }

            if(_self.isFilterColAllowed('RefreshToken')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Refresh Token', field: 'refreshTokenData',width: 200,cellEditor:'agTextCellEditor',editable:false,},
                ]);
            }

            
            if(_self.isFilterColAllowed('isPaid')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Paid', field: 'isPaid',width: commonWidth,cellRendererFramework:booleanRenderer },
                ]);
            }
            if(_self.isFilterColAllowed('isPremium')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Premium',pinned:'right', field: 'isPremium',width: commonWidth ,cellRendererFramework:booleanRenderer},
                ]);
            }
            if(_self.isFilterColAllowed('isActive')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Active', field: 'isActive',width: commonWidth,cellRendererFramework:booleanRenderer },
                ]);
            }
            if(_self.isFilterColAllowed('isDeleted')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Deleted',field: 'isDeleted',width: commonWidth ,cellRendererFramework:booleanRenderer},
                ]);
            }
            if(_self.isFilterColAllowed('updatedOn')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Updated On', field: 'updatedOn', width: 160, cellRendererFramework: dateTimeRenderer },
                ]);
            }
            
            if(_self.isFilterColAllowed('actions')){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Actions',field: 'userId',autoHeight:true,minWidth:500,width: commonWidth,cellRendererFramework:devopsCustomerActionsRenderer },
                ]);
            }
            if(_self.isFilterColAllowed('Extras') || 1==1){
                columnDefs=columnDefs.concat([ 
                    { headerName: 'Extra Actions',field: 'userId',autoHeight:true,minWidth:250,width: commonWidth,cellRendererFramework:devopsExtraActionsRenderer },
                ]);
            }

         
            setTimeout(function(){_self.columnDefs=columnDefs;},500);
            _self.initPaymentCols();
        },
        initCols1(){
            const _self  =this;
            _self.columnDefs=[];
            let tabIndex=_self.tabIndex;

            let commonWidth=125;//=120;
            let columnDefs = [
                { headerName: 'App',pinned:'left',maxWidth:90, field: 'requestType',cellClass:'text-capitalize', width: commonWidth,
                    valueFormatter:function(params){return params.value.split('-')[0];} 
                },
                { headerName: 'Valid - Created', field: 'validUntil',width: commonWidth,
                    valueFormatter:function(params){
                        let date=_self.filter().formatDate(params.data.createdOn);
                        let date1=_self.filter().formatDate(params.value);
                        return `${date1?date1:'-'}/${date?date:'-'}`;
                    }
                },
                { headerName: 'User Email', field: 'userEmail',width: commonWidth,cellRendererFramework:copyColumnRenderer, valueFormatter(params){
                    return params.value?params.value:params.data.hdEmail;
                } },
                { headerName: 'Tickets Count', field: 'linkedCount',width: commonWidth,
                    cellRenderer:function(params){
                        return `<a href="/admin/tickets/${params.data.userId}/${params.data.requestType}" target="_blank">${params.value}</a>`;
                    } 
                },
                { headerName: 'Last Tickets', field: 'lastDayCount',width: commonWidth,
                    valueFormatter:function(params){
                        return `${params.data.currentDayCount}/${params.value}`
                    }
                },
                { headerName: 'Last Used On', field: 'currentDayUsedOn',width: commonWidth,
                    valueFormatter:function(params){
                        let date=_self.filter().formatDate(params.value);
                        let date1=_self.filter().formatDate(params.data.currentDayUsedOn);
                        return `${date1?date1:'-'}/${date?date:'-'}`;
                    }
                },
                { headerName: 'HD Login Url', field: 'hdLoginUrl',width: commonWidth,cellRendererFramework:copyColumnRenderer },
                { headerName: 'Notify', field: 'requestType',autoHeight:true,width: commonWidth,cellRendererFramework:notifyRenderer },
                { headerName: 'Customize', field: 'userId',autoHeight:true,editable:true, width: commonWidth,cellRendererFramework:customizeRenderer },
                { headerName: 'User Id', field: 'userId', width: commonWidth,cellClass:'text-left'},
                { headerName: 'App Id', field: 'appId', width: commonWidth,
                    cellEditor:'agTextCellEditor',editable:true,
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.appId=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Installation Id', field: 'installationId', width: commonWidth,
                    cellEditor:'agTextCellEditor',editable:true,
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.installationId=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                //{ headerName: 'User Name', field: 'userName',width: commonWidth },
                //{ headerName: 'HD Email', field: 'hdEmail',width: commonWidth },
                //{ headerName: 'HD Token', field: 'hdToken',width: commonWidth },
                { headerName: 'DevOps Url', field: 'devOpsUrl',width: commonWidth,cellRendererFramework:copyColumnRenderer},
                //{ headerName: 'DevOps Token', field: 'devOpsToken',width: commonWidth},
                { headerName: 'HD Status', field: 'hdStatus',width: 170,
                    cellEditor:'agTextCellEditor',editable:true,
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.hdStatus=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'DevOps Status', field: 'devopsStatus',width: 170,
                    cellEditor:'agTextCellEditor',editable:true,
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.devopsStatus=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'DevOps Status Desc', field: 'devopsStatusDesc',width: 250,
                    cellEditor:'agTextCellEditor',editable:true,
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.devopsStatusDesc=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'HD AuthorId', field: 'hdAuthorId',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.hdAuthorId=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'ByPass Rules', field: 'bypassRules',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.bypassRules=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Sync All Sts', field: 'devSyncAllSts',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.devSyncAllSts=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Custom Supp Name', field: 'hdSupName',width: 170,
                    cellEditor:'agTextCellEditor',editable:true,
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.hdSupName=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Allow Search', field: 'allowSearch',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowSearch=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Allow Config Opt', field: 'allowConfigOpt',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowConfigOpt=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Allow HD Desc', field: 'autoHDDesc',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.autoHDDesc=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Auto Create ADO', field: 'autoCreateADO',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.autoCreateADO=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Auto Create HD', field: 'autoCreateHD',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.autoCreateHD=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Notes', field: 'notes',width: 250,autoHeight: true,
                    minWidth: 250,
                    cellEditor:'agLargeTextCellEditor',editable:true,cellStyle:{'white-space': 'normal'},
                    // cellEditorParams: (params) => {
                    //     return {
                    //         maxLength: '1000',
                    //         cols: 20,
                    //         rows: 200
                    //     }
                    // },
                    onCellValueChanged: (params) => {
                        if(params.oldValue!=params.newValue){
                            params.data.notes=params.newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Allowed Count', field: 'allowedCount',width: commonWidth },
                { headerName: 'Allowed Tags', field: 'allowTags',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    //cellEditorParams: { values: ['Yes','No'] },
                    cellEditorParams: { values: [1,0] },
                    filterParams: {
                        // valueFormatter: (params) => {
                        //     return params.value==1?'Yes':'No'
                        // },
                    },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowTags=newValue;
                            _self.updateCustomer(params.data);
                        }
                        // let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        // if(params.oldValue!=newValue){
                        //     params.data.allowTags=newValue;
                        //     _self.updateCustomer(params.data);
                        // }
                    },
                    //cellRendererFramework:booleanRenderer
                },
                { headerName: 'Allowed HD Tags', field: 'allowHDTags',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowHDTags=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Allow Fields', field: 'allowFields',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    //cellEditorParams: { values: ['Yes','No'] },
                    cellEditorParams: { values: [1,0] },
                    filterParams: {
                        // valueFormatter: (params) => {
                        //     return params.value==1?'Yes':'No'
                        // },
                    },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowFields=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Allow Nodes', field: 'allowNodes',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowNodes=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                
                { headerName: 'Allow CTypes', field: 'allowCTypes',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    filterParams: {
                    },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowCTypes=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },

                { headerName: 'Allow Multi User OAuth', field: 'allowMultiUserOAuth',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    filterParams: {
                    },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.allowMultiUserOAuth=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Auto Sync', field: 'autoSyncing',width: 170,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: ['Select','all','tag_based','status'] },
                    filterParams: {
                        valueFormatter: (params) => {
                            return params.value==null?'Select':params.value;
                        },
                    },
                    onCellValueChanged:function(params,s){
                        let newValue=params.newValue;
                        if(newValue=='Select'){
                            newValue=null;
                        }
                        if(params.oldValue!=newValue){
                            params.data.autoSyncing=newValue;
                            _self.updateCustomer(params.data);
                        }
                    }
                },
                { headerName: 'Auto Sync Fwd', field: 'autoSyncingFwd',width: 170,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: ['Select','all','tag_based','private'] },
                    filterParams: {
                        valueFormatter: (params) => {
                            return params.value==null?'Select':params.value;
                        },
                    },
                    onCellValueChanged:function(params,s){
                        let newValue=params.newValue;
                        if(newValue=='Select'){
                            newValue=null;
                        }
                        if(params.oldValue!=newValue){
                            params.data.autoSyncingFwd=newValue;
                            _self.updateCustomer(params.data);
                        }
                    }
                },
                { headerName: 'Syncing Allowed', field: 'syncAllowed',width: 170,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: ['Select','Forward','Reverse','Both'] },
                    filterParams: {
                        valueFormatter: (params) => {
                            return params.value==null?'Select':params.value;
                        },
                    },
                    onCellValueChanged:function(params,s){
                        let newValue=params.newValue;
                        if(newValue=='Select'){
                            newValue=null;
                        }
                        if(params.oldValue!=newValue){
                            params.data.syncAllowed=newValue;
                            _self.updateCustomer(params.data);
                            if(newValue){
                                params.data.type='syncing';
                                setTimeout(function(){
                                    _self.sendNotification(params.data);
                                },1000);
                            }
                        }
                    }
                },
                { headerName: 'Sync Attach..', field: 'syncAttachments',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.syncAttachments=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Upload Files', field: 'uploadFiles',width: 150,
                    cellEditor: 'agSelectCellEditor',editable:true,
                    cellEditorParams: { values: [1,0] },
                    onCellValueChanged: (params) => {
                        let newValue=(params.newValue=='Yes' || params.newValue==1)?1:0;
                        if(params.oldValue!=newValue){
                            params.data.uploadFiles=newValue;
                            _self.updateCustomer(params.data);
                        }
                    },
                },
                { headerName: 'Paid', field: 'isPaid', width: commonWidth, cellRendererFramework: booleanRenderer },
                { headerName: 'Premium', pinned: 'right', field: 'isPremium', width: commonWidth, cellRendererFramework: booleanRenderer },
                { headerName: 'Actions',field: 'userId',autoHeight:true,minWidth:950,width: commonWidth,cellRendererFramework:devopsCustomerActionsRenderer },
            ];
            setTimeout(function(){_self.columnDefs=columnDefs;},500);
            _self.initPaymentCols();
        },
        initPaymentCols(){
            const _self  =this;
            let commonWidth=125;//=120;
            _self.payments.columnDefs = [
            { headerName: 'Id',field: 'id',width: commonWidth },
            //{ headerName: 'User Id',field: 'userId',width: commonWidth },
            { headerName: 'App Name', field: 'appName',width: commonWidth },
            { headerName: 'Plan Name', field: 'planName', width: commonWidth,cellClass:'text-left'},
            { headerName: 'Paid Amount', field: 'paidAmount',width: commonWidth },
            { headerName: 'Valid Until', field: 'validUntil',width: commonWidth, cellRendererFramework:dateTimeRenderer },
            { headerName: 'Plan Validity', field: 'planValidity',width: commonWidth },
            { headerName: 'Invoice Number', field: 'invoiceNumber',width: commonWidth },
            { headerName: 'Customer Type', field: 'customerType',width: commonWidth },
            { headerName: 'Start Date', field: 'startDate',width: commonWidth ,cellRendererFramework:dateTimeRenderer },
            { headerName: 'End Date', field: 'endDate',width: commonWidth ,cellRendererFramework:dateTimeRenderer },
            { headerName: 'Plan Type', field: 'planType',width: commonWidth },
            { headerName: 'Notes', field: 'notes',width: commonWidth },
            { headerName: 'Active', field: 'isActive',width: commonWidth,cellRendererFramework:booleanRenderer},
            { headerName: 'Deleted', field: 'isDeleted',width: commonWidth,cellRendererFramework:booleanRenderer},
            { headerName: 'Created On', field: 'createdOn',width: commonWidth,cellRendererFramework:dateTimeRenderer },
            ];
        }
    },
    components:{customAgGrid,DatePicker,Multiselect,[Select.name]: Select,[Option.name]: Option,DevopsFieldMapping}
}

